import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslationService } from './modules/i18n';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { AppConfigService } from './core/services/app-config.service';
// import { FcmService } from './core/services/fcm.service';
import { AuthService, UserModel } from './modules/auth';
// import { filter, take } from 'rxjs';

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    public appConfig: AppConfigService,
    // private fcmService: FcmService,

  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );
  }

  ngOnInit() {
    this.modeService.init();

    // this.authService.currentUser$
    //   .pipe(
    //     filter((user): user is UserModel => !!user?.id),
    //     take(1)
    //   )
    //   .subscribe(user => {
    //     this.fcmService.init(user.id);
    //   });
  }
}
